import request from 'umi-request';
export function event(data: any) {
  request.post(process.env.NEXT_PUBLIC_EVENT as string, { data });
}
